

















import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';

@Component({})
export default class BookmarkAdd extends Vue {
  @Prop()
  index: number;

  @Prop()
  item: any;

  @Prop()
  title: string;

  switchMenu() {
    this.bus.emit('open-dialog', { name: 'BookmarkAddDialog', data: { index: this.index, item: this.item, title: this.title } })
  }
}
